import { setLoading } from '../app/actions';

const defaultHandleResponse = arg => arg;
const defaultHandleError = arg => Promise.reject(arg);

const apiFetch = ({ body, method, path, token }) =>
  fetch(path, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  });

export default function apiMiddleware({
  apiActionType,
  responseStatusActionCreators,
  rootUrl,
  tokenSelector,
}) {
  return store => next => action => {
    if (action.type !== apiActionType) {
      return next(action);
    }

    const token = tokenSelector(store.getState());

    const {
      handleError = defaultHandleError,
      handleResponse = defaultHandleResponse,
      path,
      responseType,
      ...request
    } = action.payload;

    return apiFetch({
      ...request,
      path: `${rootUrl}${path}`,
      responseType,
      token,
    })
      .then(response => {
        const { status, statusText } = response;
        if (responseStatusActionCreators[status]) {
          return next(responseStatusActionCreators[status](response));
        }

        if (!response.ok) {
          return response.json().then(body => {
            return Promise.reject({ body, status, statusText });
          });
        }

        return responseType === 'blob' ? response.blob() : response.json();
      })
      .then(handleResponse)
      .catch(handleError);
  };
}



// WEBPACK FOOTER //
// ./src/store/middleware/apiMiddleware.js